import { useRef, useEffect } from 'react'

import Styled from './styled'
import * as d3 from 'd3'

import _ from 'lodash'

export default function D3Bar ({ data, width, keys, indexBy }) {
  const svgRef = useRef(null)
  const height = 500
  const margin = { top: 20, right: 300, bottom: 30, left: 30 }
  const svgWidth = width + margin.left + margin.right
  const svgHeight = height + margin.top + margin.bottom
  const format = (num) => {
    const tonum = Number(num)
    return _.isNaN(num)
      ? 0
      : new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(tonum)
  }
  useEffect(() => {
    console.log(d3.schemeBlues)
    let range = 3
    if (keys.length > range) {
      if (keys.length < 9) {
        range = keys.length
      } else {
        range = 9
      }
    }
    const color = d3
      .scaleOrdinal()
      .domain(keys)
      .range(d3.schemeBlues[range])
    const svgEl = d3.select(svgRef.current)
    svgEl.selectAll('*').remove() // Clear svg content before adding new elements
    const svg = svgEl.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

    const y1 = d3
      .scaleLinear()
      .domain([
        0,
        d3.max(data, (value) => {
          return d3.max(keys, (key) => value[key])
        }),
      ])
      .rangeRound([height - margin.bottom, margin.top])
    const x = d3
      .scaleBand()
      .domain(
        data.map((d) => {
          return d[indexBy]
        })
      )
      .rangeRound([margin.left, width - margin.right])
      .padding(0.1)

    const x1 = d3
      .scaleBand()
      .domain(keys)
      .rangeRound([0, x.bandwidth()])
      .padding(0.1)

    const xAxis = (g) =>
      g.attr('transform', `translate(0,${height - margin.bottom})`).call(
        d3
          .axisBottom(x)
          .tickValues(x.domain())
          .tickSizeOuter(0)
      )

    const y1Axis = (g) =>
      g
        .attr('transform', `translate(${margin.left},0)`)
        .call(d3.axisLeft(y1).ticks(null, 's'))
        .call((g) => g.select('.domain').remove())
        .call((g) =>
          g
            .append('text')
            .attr('x', -margin.left)
            .attr('y', 10)
            .attr('fill', 'currentColor')
            .attr('text-anchor', 'start')
            .text('Amount')
        )
    const y2 = d3
      .scaleLinear()
      .domain([0, d3.max(data, (d) => d.total)])
      .rangeRound([height - margin.bottom, margin.top])

    const y2Axis = (g) =>
      g
        .attr('transform', `translate(${width - margin.right},0)`)
        .call(d3.axisRight(y2))
        .call((g) => g.select('.domain').remove())
        .call((g) =>
          g
            .append('text')
            .attr('x', 30)
            .attr('y', 10)
            .attr('fill', 'currentColor')
            .attr('text-anchor', 'end')
            .text('Event')
        )

    const line = d3
      .line()
      .x((d) => x(d[indexBy]) + x.bandwidth() / 2)
      .y((d) => y2(d.total))

    const div = d3
      .select('body')
      .append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0)

    const slice = svg
      .append('g')
      .selectAll('g')
      .data(data)
      .enter()
      .append('g')
      .attr('class', 'g')
      .attr('transform', function (d) {
        return 'translate(' + x(d.period) + ',0)'
      })

    slice
      .selectAll('rect')
      .data(function (d) {
        return keys.map((item) => {
          return {
            value: d[item],
            key: item,
          }
        })
      })
      .enter()

      .append('rect')
      .attr('width', x1.bandwidth())
      .attr('x', function (d) {
        return x1(d.key)
      })

      .style('fill', function (d) {
        return color(d.key)
      })
      .attr('y', function (d) {
        return y1(0) - margin.bottom
      })
      .attr('height', function (d) {
        return height - y1(0)
      })
    slice
      .selectAll('rect')
      .transition()
      .duration(1000)
      .attr('y', function (d) {
        return y1(d.value)
      })

      .attr('height', function (d) {
        return height - margin.bottom - y1(d.value)
      })

    slice
      .selectAll('text')
      .data(function (d) {
        return keys.map((item) => {
          return {
            value: d[item],
            key: item,
          }
        })
      })
      .enter()
      .append('text')
      .text(function (d) {
        const data = format(d.value)
        return isNaN(d.value) ? '' : data
      })
      .attr('text-anchor', 'start')
      .attr('dominant-baseline', 'start')
      .attr('transform', 'rotate(-90)')

      .attr('y', function (d) {
        return x1(d.key) + x1.bandwidth() / 2 + 10
      })
      .attr('x', function (d) {
        // return -y1(d.value) + 5
        return -svgHeight + 90
      })

    // svg
    //   .append('g')
    //   .selectAll('g')
    //   .data(stackedData)
    //   .enter()
    //   .append('g')
    //   .attr('fill', function (d) {
    //     return color(d.key)
    //   })
    //   .selectAll('rect')
    //   .data(function (d) {
    //     return d
    //   })
    //   .enter()
    //   .append('rect')
    //   .attr('x', function (d) {
    //     return x(d.data[indexBy])
    //   })
    //   .attr('y', function (d) {
    //     return y1(d[1])
    //   })
    //   .attr('height', function (d) {
    //     return y1(d[0]) - y1(d[1])
    //   })
    //   .attr('width', x.bandwidth())

    svg
      .append('path')
      .attr('fill', 'none')
      .attr('stroke', 'red')
      .attr('stroke-miterlimit', 1)
      .attr('stroke-width', 3)
      .attr('d', line(data))

    svg
      .append('g')
      .selectAll('dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('fill', 'red')
      .attr('cx', function (d) {
        return x(d[indexBy]) + x.bandwidth() / 2
      })
      .attr('cy', function (d) {
        return y2(d.total)
      })
      .attr('r', 5)
      .on('mouseover', function (event, d) {
        let html = ''
        keys.map((item) => {
          html += `<br/>${item}: ${format(d[item] || 0)}`
          return ''
        })
        div
          .transition()
          .duration(200)
          .style('opacity', 1)
        div
          .html(
            `<span>
            <p class="title">${d[indexBy]}<p>
            total: ${format(d.total)}
            ${html}
            </span>`
          )
          .style('left', event.pageX + 'px')
          .style('transform', 'translateX(-50%)')
          .style('top', event.pageY - 210 + 'px')
      })
      .on('mouseout', function (d) {
        div
          .transition()
          .duration(500)
          .style('opacity', 0)
      })

    svg
      .append('g')
      .selectAll('text')
      .data(data)
      .enter()
      .append('text')
      .text(function (d) {
        return d?.total
      })
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'middle')
      .attr('transform', 'rotate(-90)')
      .attr('y', function (d) {
        return x(d[indexBy]) + x.bandwidth() / 2
      })
      .attr('x', function (d) {
        return -y2(d.total) + 15
      })

    svg
      .append('g')
      .attr('class', 'x axis')
      .attr('id', 'x')
      .call(xAxis)
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', function (d) {
        return 'rotate(-30)'
      })

    svg.append('g').call(y1Axis)

    svg.append('g').call(y2Axis)
    const legendRectSize = 18
    const legendSpacing = 4
    var legend = svg
      .selectAll('.legend')
      .data(color.domain())
      .enter()
      .append('g')
      .attr('class', 'legend')
      .attr('transform', function (d, i) {
        var height = legendRectSize + legendSpacing
        var offset = (height * color.domain().length) / 2
        var horz = width - margin.right + 50
        var vert = svgHeight - margin.top - margin.bottom - 25 - (i * height + offset)
        return 'translate(' + horz + ',' + vert + ')'
      })

    legend
      .append('rect')
      .attr('width', legendRectSize)
      .attr('height', legendRectSize)
      .style('fill', color)
      .style('stroke', color)

    legend
      .append('text')
      .attr('x', legendRectSize + legendSpacing)
      .attr('y', legendRectSize - legendSpacing)
      .text(function (d) {
        return d
      })
  }, [data, indexBy, keys, margin.bottom, margin.left, margin.right, margin.top, svgHeight, width])
  return (
    <Styled className='d3Bar-component'>
      <svg ref={svgRef} width={width} height={svgHeight} />
    </Styled>
  )
}
